module.exports = __webpack_public_path__ + "static/media/GothamRnd-Bold.a17abd06.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Bold.otf
 ** module id = 1345
 ** module chunks = 0
 **/